import { doc, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../config/firebaseConfig';
import { UserAuth } from '../context/authContext';

const channel = new BroadcastChannel('game_state_sync');

export const useGameStateSync = () => {
  const { userData } = UserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [roomId, setRoomId] = useState(localStorage.getItem('roomId') || '');

  useEffect(() => {
    let unsubscribe;

    if (roomId && userData?.publicKey) {
      const roomRef = doc(db, 'rooms', roomId);
      unsubscribe = onSnapshot(roomRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          
          // Post message to other tabs
          channel.postMessage({ type: 'state_change', roomData: data });

          // Handle navigation for the current tab
          handleNavigation(data);

        } else {
          // Room deleted
          channel.postMessage({ type: 'room_deleted' });
          handleRoomDeleted();
        }
      });
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId, userData?.publicKey, navigate, location.pathname]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === 'state_change') {
        handleNavigation(event.data.roomData);
      } else if (event.data.type === 'room_deleted') {
        handleRoomDeleted();
      }
    };

    channel.addEventListener('message', handleMessage);

    return () => {
      channel.removeEventListener('message', handleMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, location.pathname]);

  const handleNavigation = (roomData) => {
    const stage = roomData.gameState?.stage;
    const currentPath = location.pathname;

    const playingStageRoutes = ['/mempool', '/blocks', '/create', '/my-transactions'];
    
    const gameLoopRoutes = ['/game', '/leaderboard', '/lobby', ...playingStageRoutes];

    if (!gameLoopRoutes.includes(currentPath)) {
      return;
    }

    if (stage !== 'PLAYING' && playingStageRoutes.includes(currentPath)) {
        navigate('/game');
    }
  };

  const handleRoomDeleted = () => {
      localStorage.removeItem('roomId');
      localStorage.removeItem('role');
      navigate('/');
  }

  return null;
};
